import React from 'react';
import { FaGraduationCap, FaBriefcase, FaStethoscope } from 'react-icons/fa';
import './OverView.css';

const OverView = ({ data }) => {
	if (!data) return null;

	const fullName = `Dr. ${[data.firstName, data.lastName].filter(Boolean).join(' ')}`;
	const services = data.services ? String(data.services).split(',').map(s => s.trim()).filter(Boolean) : [];
	const specializations = data.specialization ? [data.specialization] : [];

	return (
		<div className="overview-container">
			<div className="overview-grid">
				<div className="overview-main">
					{data.biography && (
						<section className="overview-section">
							<h3 className="overview-section__title">About</h3>
							<p className="overview-section__text">{data.biography}</p>
						</section>
					)}

					{data.degree && (
						<section className="overview-section">
							<h3 className="overview-section__title">
								<FaGraduationCap className="overview-section__icon" /> Education
							</h3>
							<div className="timeline">
								<div className="timeline-item">
									<div className="timeline-marker" />
									<div className="timeline-content">
										<div className="timeline-header">
											<h4>{data.degree}</h4>
											{data.completionYear && <span className="timeline-year">{data.completionYear}</span>}
										</div>
										{data.college && <p className="timeline-institution">{data.college}</p>}
									</div>
								</div>
							</div>
						</section>
					)}

					{data.experience && (
						<section className="overview-section">
							<h3 className="overview-section__title">
								<FaBriefcase className="overview-section__icon" /> Experience
							</h3>
							<div className="timeline">
								<div className="timeline-item">
									<div className="timeline-marker" />
									<div className="timeline-content">
										<div className="timeline-header">
											<h4>{data.designation || 'Medical Professional'}</h4>
											<span className="timeline-year">{data.experience}</span>
										</div>
										{data.experienceHospitalName && <p className="timeline-institution">{data.experienceHospitalName}</p>}
										{data.clinicName && <p className="timeline-institution">{data.clinicName}</p>}
									</div>
								</div>
							</div>
						</section>
					)}
				</div>

				<div className="overview-sidebar">
					{services.length > 0 && (
						<section className="overview-card">
							<h3 className="overview-card__title">
								<FaStethoscope className="overview-card__icon" /> Services Offered
							</h3>
							<ul className="services-list">
								{services.map((service, index) => (
									<li key={index}>{service}</li>
								))}
							</ul>
						</section>
					)}

					{specializations.length > 0 && (
						<section className="overview-card">
							<h3 className="overview-card__title">Specialization</h3>
							<div className="specializations-list">
								{specializations.map((spec, index) => (
									<span className="specialization-tag" key={index}>{spec}</span>
								))}
							</div>
						</section>
					)}
				</div>
			</div>
		</div>
	);
};

export default OverView;
